import CreateCourseScheduleBlock from './CreateCourseScheduleBlock';
import { CreateCourseScheduleBlockProps, CreateCourseScheduleBlockValueProps } from './types';

export type { CreateCourseScheduleBlockProps, CreateCourseScheduleBlockValueProps };
export default CreateCourseScheduleBlock;
